import { BrandOcelotConfig } from '@/types/ocelotConfig';

const AllasConfig: BrandOcelotConfig = {
  search: {
    googleCustomSearch: {
      id: '008262495618786222540:qjoitett5ht',
    },
    placeholderImage: '/image/allas-logo.svg',
  },
  analytics: {
    brandName: 'allas',
    google: {
      dimensions: {
        page_id: '1',
        mobile_website: '2',
      },
      viewId: 141882424,
      hostname: 'www.allas.se',
    },
    parsely: {
      siteId: 'allas.se',
    },
    avo: {
      apiKey: 'blcuGqEsX2nT6VJtqDMv',
    },
    funnelRelay: {
      customerId: 'aller_e7bce_allas',
      scriptSource: 'cdn-magiclinks.trackonomics.net/client/static/v2/aller_e7bce_allas.js',
    },
    tags: ['funnelRelay', 'engagedTime', 'scrollDepthTracker', 'loggedInId', 'metadata', 'webVitals'],
    jwplayer: true,
  },
  features: {
    login: {
      enabled: true,
    },
    infinityScrollArticle: {
      enabled: true,
    },
    keesingGames: {
      enabled: true,
      customerId: 'allas',
      scriptPath: 'https://web.braintainment.com/pub/bundle-loader/bundle-loader.js',
      stylesPath: 'https://web.braintainment.com/pub/config/allas/css/custom_client.css',
      frontPagePathname: '/korsord-och-spel',
    },
    article: {
      saveArticle: {
        enabled: true,
      },
    },
    trendingMenu: {
      label: 'Lästips:',
      tagPrefixes: ['nytt!'],
    },
    payments: {
      enabled: true,
      defaultPlan: 'allas-plus-monthly',
      bffOAuth: {
        scope: 'payment entitlement:allas introspect',
        audience: 'sweden',
      },
    },
    newsletterSignup: {
      enabled: true,
      availableNewsletters: {
        ALLAS: { label: 'Allas' },
        ANTIK_AUKTION: { label: 'Antik & Auktion' },
        RECEPT: { label: 'Recept.se' },
      },
    },
    infinityScrollFront: {
      title: 'Senaste från Allas',
      explicitRoute: [
        {
          accessLevel: 'purchase',
          route: 'etikett/allas plus',
        },
      ],
    },
    articleTeaser: {
      inject: true,
      title: 'Kickstarta hjärnan i höst – spela kryss och spel på allas.se',
      imageUrl: 'https://www.allas.se/files/2026/07/01/crossword-games.jpg',
      exclude: {
        accessLevels: ['purchase'],
        categories: ['creative-studio', 'creative studio'],
      },
    },
  },

  seo: {
    schemaMarkup: {
      name: 'Allas',
      foundingDate: '1931-01-01',
      alternateName: ['Allas.se'],
      sameAs: [
        'https://sv.wikipedia.org/wiki/Allas',
        'https://www.wikidata.org/wiki/Q10405561',
        'https://www.pinterest.se/allas_se/',
        'https://www.youtube.com/channel/UCbhwNRc_wF3tpAkM2feMTFA',
        'https://sv-se.facebook.com/allasveckotidning/',
        'https://www.instagram.com/allas.se/',
      ],
      publishingPrinciples: '',
      verificationFactCheckingPolicy: '',
      correctionsPolicy: '',
      unnamedSourcesPolicy: '',
      missionCoveragePrioritesPolicy: '',
      webPages: ['/shop', '/om-oss', '/om-cookies', '/login', '/alla-amnen', '/nyhetsbrev', '/vara-skribenter'],
    },
  },
  ads: {
    exceptionPaths: {
      '^korsord-och-spel$': {
        aboveBody: true,
        extraStartCount: 5000,
        useHeights: false,
      },
      '^korsord-och-spel/\\S+$': {
        extraStartCount: 5000,
        useHeights: false,
      },
    },
    video: {
      clickToPlay: '0XDonXQi',
      autoPlay: 'a4kkgt0P',
      videoPage: 'na7OwFdn',
    },
  },
  common: {
    redirects: [
      {
        from: '^korsord-och-spel/',
        to: 'korsord-och-spel',
      },
    ],
  },
};

export default AllasConfig;
